import { Skeleton, useMantineTheme } from '@mantine/core';

import repeat from '~/common/utils/repeat';

import { useStyles, CAROUSEL_CARD_HEIGHT } from './HomePredictionMarkets.styles';

const SKELETON_CARD_COUNT = 2;

export function CarouselSkeleton() {
  const { classes } = useStyles();
  const theme = useMantineTheme();

  return (
    <div className={classes.skeletonRow}>
      {repeat(SKELETON_CARD_COUNT, (index) => (
        <Skeleton
          key={index}
          className={classes.skeletonCard}
          height={CAROUSEL_CARD_HEIGHT}
          radius={theme.radius.lg}
        />
      ))}
    </div>
  );
}
